import { REGEXP_EMAIL } from '@/constants/regex';
import { useBizState } from './use-biz-state';

export const useDisplayAccount = () => {
  const { areaCode, userName } = useBizState();

  return {
    displayAccount: REGEXP_EMAIL.test(userName) ? userName : `${areaCode} ${userName}`,
  };
};
